import React, { useState, useRef, useEffect } from 'react';

export default function ProductSearch({ products = [], value, onChange, placeholder = 'Search or enter product name' }) {
  const [query, setQuery]     = useState(value?.name || '');
  const [open, setOpen]       = useState(false);
  const containerRef          = useRef(null);

  // Sync if parent clears the value
  useEffect(() => {
    if (!value) setQuery('');
  }, [value]);

  // Close dropdown on outside click
  useEffect(() => {
    const handler = (e) => { if (!containerRef.current?.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const filtered = query.trim()
    ? products.filter(p => p.name.toLowerCase().includes(query.toLowerCase()))
    : products;

  const handleInput = (e) => {
    const q = e.target.value;
    setQuery(q);
    setOpen(true);
    // Signal a new (not-yet-saved) product name, no id
    onChange({ id: null, name: q });
  };

  const handleSelect = (product) => {
    setQuery(product.name);
    setOpen(false);
    onChange(product);
  };

  const isNew = query.trim() && !products.some(p => p.name.toLowerCase() === query.toLowerCase());

  return (
    <div ref={containerRef} style={{ position: 'relative' }}>
      <input
        type="text"
        value={query}
        onChange={handleInput}
        onFocus={() => setOpen(true)}
        placeholder={placeholder}
        style={{ width: '100%' }}
        autoComplete="off"
      />

      {open && (filtered.length > 0 || isNew) && (
        <div style={{
          position: 'absolute', top: 'calc(100% + 4px)', left: 0, right: 0,
          background: 'var(--color-surface)', border: '1px solid var(--color-border)',
          borderRadius: 'var(--radius-sm)', zIndex: 50, maxHeight: '200px', overflowY: 'auto',
          boxShadow: '0 4px 16px rgba(0,0,0,0.3)',
        }}>
          {filtered.map(p => (
            <div
              key={p.id}
              onMouseDown={() => handleSelect(p)}
              style={{
                padding: '0.6rem 0.85rem', cursor: 'pointer', fontSize: '0.88rem',
                borderBottom: '1px solid var(--color-border)',
              }}
              onMouseEnter={e => e.currentTarget.style.background = 'var(--color-surface2)'}
              onMouseLeave={e => e.currentTarget.style.background = ''}
            >
              <span style={{ fontWeight: 500 }}>{p.name}</span>
              {p.stock_qty !== undefined && (
                <span style={{ float: 'right', fontSize: '0.75rem', color: 'var(--color-muted)' }}>
                  stock: {Number(p.stock_qty).toFixed(2)}
                </span>
              )}
            </div>
          ))}
          {isNew && (
            <div
              onMouseDown={() => { setOpen(false); onChange({ id: null, name: query.trim() }); }}
              style={{
                padding: '0.6rem 0.85rem', cursor: 'pointer', fontSize: '0.85rem',
                color: 'var(--color-primary)', fontWeight: 600,
              }}
              onMouseEnter={e => e.currentTarget.style.background = 'var(--color-surface2)'}
              onMouseLeave={e => e.currentTarget.style.background = ''}
            >
              + Add "{query.trim()}" as new product
            </div>
          )}
        </div>
      )}
    </div>
  );
}
